import NextLink from 'next/link';

import {Icon, Text} from '#component/base';
import {HoverEffect} from '#component/util';
import {ImpactLevel, ImpactLevelMap} from '#constant/impactLevel';
import {sprinkles} from '#style/sprinkles';

import * as css from './HealthFactorCard.css';

export const HealthFactorCard = ({
  href = '',
  headline = '',
  impact = ImpactLevel.high,
  practicing = false,
  ...otherProps
}) => {
  return (
    <NextLink passHref href={href}>
      <Text aria-label={headline} as="a" className={css.root({impact, practicing})} {...otherProps}>
        <Text
          as="p"
          color="inherit"
          className={sprinkles({flex: 'flex', content: 'between', items: 'center'})}
          variant="label">
          {practicing ? 'Keep it up' : 'Start doing'} • {ImpactLevelMap[impact]}
          <Icon
            aria-hidden
            color="currentColor"
            name={practicing ? 'CheckCircle' : 'WarningCircle'}
            weight="bold"
          />
        </Text>

        <div className={sprinkles({flex: 'flex', dir: 'col', gap: 32})}>
          <Text className={css.headline({impact, practicing})} color="inherit" variant="bodyXLarge">
            {headline}
          </Text>

          <Text className={css.learnMore({practicing})}>
            Learn more
            <Icon aria-hidden color="currentColor" name="CaretRight" size="small" weight="bold" />
          </Text>
        </div>
        <HoverEffect variant={impact ? impact : 'primary'} />
      </Text>
    </NextLink>
  );
};
